import React, { ReactNode, ErrorInfo } from 'react';
import Modal from '../Modal';
import { logEvent } from '../../utils/logger';
import { LEVELS, SEVERITY } from 'src/constants';
interface ErrorBoundaryProps {
  children: ReactNode;
}

interface ErrorBoundaryState {
  hasError: boolean;
  error: Error | null;
  errorInfo: ErrorInfo | null;
}

class ErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
  state: ErrorBoundaryState = {
    hasError: false,
    error: null,
    errorInfo: null,
  };

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    this.setState({
      hasError: true,
      error,
      errorInfo,
    });
    logEvent({
      level: LEVELS.ERROR,
      severity: SEVERITY.HIGH,
      message: error.message || 'Unknown error in ErrorBoundary',
    });
  }

  handleClose = () => {
    this.setState({
      hasError: false,
      error: null,
      errorInfo: null,
    });
  };

  render() {
    const { hasError } = this.state;
    return (
      <>
        {hasError && (
          <Modal
            isOpen={hasError}
            color="danger"
            handleClose={this.handleClose}
            title="Une erreur s'est produite"
            message='Une erreur inconnue est survenue.'
            btnTxt="Recharger"
            btnColor="danger"
            onClick={() => window.location.reload()}
          >
            <p>Veuillez réessayer ou contactez l'assistance si le problème persiste.</p>
          </Modal>

        )}
        {this.props.children}
      </>
    );
  }
}

export default ErrorBoundary;
